import axios from 'axios';

const API_BASE = 'https://api.vadhuvarsamanvay.in/api';

export const login = async (email, password) => {
    return axios.post(`${API_BASE}/admin/login`, { email, password });
};

export const getRegistrations = async (page, limit, search) => {
    return axios.get(`${API_BASE}/registrations`, {
        params: { page, limit, search },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
};

export const getRegistrationById = async (id) => {
    return axios.get(`${API_BASE}/registrations/${id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
};

export const updatePaymentStatus = async (id, payment_status) => {
    return axios.patch(`${API_BASE}/registrations/${id}/payment`,
        { payment_status },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
};